import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Constants } from "../data/constants";
import { Observable } from "rxjs";
import { UserFeatureDto } from "../models/features/user-feature-dto.interface";
import { ToggleFeatureDto } from "../models/features/toggle-feature-dto.interface";
import { SuccessDto } from "../models/success-dto";
import { BatchToggleFeatureDto } from "../models/features/batch-toggle-feature-dto.interface";
import { AvailableFeaturesDto } from "../models/features/available-feature-dto.interface";

@Injectable({
  providedIn: "root",
})
export class FeaturesService {
  constructor(private http: HttpClient) {}

  getAllFeatures(email: string): Observable<UserFeatureDto[]> {
    return this.http.get<UserFeatureDto[]>(
      `${environment.APP_PORT + Constants.FEATURES + "/by-email/" + email}`
    );
  }

  getAllAvailableFeatures(): Observable<AvailableFeaturesDto[]> {
    return this.http.get<AvailableFeaturesDto[]>(
      `${environment.APP_PORT + Constants.FEATURES + "/available"}`
    );
  }

  enableFeature(payload: ToggleFeatureDto): Observable<SuccessDto>  {
    return this.http.post<SuccessDto>(
      `${environment.APP_PORT + Constants.FEATURES + "/enable"}`,
      payload
    );
  }

  disableFeature(payload: ToggleFeatureDto): Observable<SuccessDto>  {
    return this.http.post<SuccessDto>(
      `${environment.APP_PORT + Constants.FEATURES + "/disable"}`,
      payload
    );
  }

  batchToggleFeatures(payload: BatchToggleFeatureDto): Observable<SuccessDto> {
    return this.http.post<SuccessDto>(
      `${environment.APP_PORT + Constants.FEATURES + "/toggle/batch"}`,
      payload
    );
  }
}
